import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const token = localStorage.getItem("mediflow_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
      setSubscription(data.subscription || null);
    } catch {
      localStorage.removeItem("mediflow_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const loginSuccess = ({ token, user, tenant, subscription: sub }) => {
    localStorage.setItem("mediflow_token", token);
    setUser(user);
    setTenant(tenant);
    if (sub) setSubscription(sub);
    // fetch sub if not provided
    if (!sub) {
      api.get("/auth/me").then(({ data }) => setSubscription(data.subscription || null)).catch(() => {});
    }
  };

  const logout = () => {
    localStorage.removeItem("mediflow_token");
    setUser(null);
    setTenant(null);
    setSubscription(null);
    window.location.href = "/login";
  };

  const refreshMe = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data.user);
    setTenant(data.tenant);
    setSubscription(data.subscription || null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, subscription, loading, loginSuccess, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
